<template>
  <div class="c-checklist-band">
    <technoLogo />
    <div class="c-checklist-band__list">
      <div class="c-checklist-band__item" v-for="item in this.dataItems" :key="item.value">
        <span class="c-checklist-band__checkmark" v-if="item.checked"></span>
        <span class="c-checklist-band__text">{{ item.title }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import technoLogo from '@/components/technoLogo/technoLogo.vue';

// @ is an alias to /src
export default {
  name: 'checklist-band',
  props: {
    dataItems: Array
  },
  components: {
    technoLogo
    // Spinner
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './checklist-band';
</style>
